module.exports = __webpack_public_path__ + "img/textarea-t.f2cdd6b5.svg";